
import { Link } from "react-router-dom";

const PageList = [
    {text: "Home", link:"/"},
    {text: "Counter", link:"/counter"}
]
const Header = () => {
    return (
      <header className="App-header">
        <ul>
          {PageList.map(({ text, link }) => {
            return (<li>
              <Link to={link}>{text} </Link>
            </li>)
          })}
        </ul>
      </header>
    );
}

export default Header;